var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24"}},[_c('g',{attrs:{"transform":_vm.rotateProperty}},[_c('path',{attrs:{"d":"M18.59 13H3a1 1 0 010-2h15.59l-5.3-5.3a1 1 0 111.42-1.4l7 7a1 1 0 010 1.4l-7 7a1 1 0 01-1.42-1.4l5.3-5.3z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }